import { useWatch } from 'react-hook-form';

import { useSankeyFormContext } from 'contexts/sankeyFormContext';
import { FlexProps } from 'ui/Layout';

import { useAppEnvironmentContext } from '../../contexts/appEnvironmentContext';

export const useCanvasColumnProps = (): FlexProps => {
  const { appEnvironment } = useAppEnvironmentContext();
  const { form } = useSankeyFormContext();

  const [canvasWidth = 0] = useWatch({
    control: form.control,
    name: ['canvas_width'],
  });

  return {
    alignItems: 'stretch',
    flexDirection: 'column',
    gap: 4,
    // Even if the canvas width is smaller than 330px, we want to render it at least at this width
    minW: 330,
    // Cap max rendered chart width at the canvas width (+ 2px to account for the borders)
    // in the web app and scale the chart to full container width in the Office add-in
    maxW: appEnvironment === 'web' ? canvasWidth + 2 : 'auto',
  };
};
